import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import init from './firebase';
import { FiLogOut } from 'react-icons/fi';

const Logout = () => {
    const navigate = useNavigate();
    const [isLoggingOut, setIsLoggingOut] = useState(true);

    useEffect(() => {
        const performLogout = async () => {
            try {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                
                await new Promise(resolve => setTimeout(resolve, 1000));
                
                // Redirect to login
                navigate('/', { replace: true });
            } catch (error) {
                console.error('Logout error:', error);
                // Even if Firebase sign out fails, still redirect
                navigate('/', { replace: true });
            }
        };

        performLogout();
    }, [ navigate]);

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center"
             style={{
                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                 padding: '20px'
             }}>
            <div className="card shadow-lg text-center p-5"
                 style={{
                     maxWidth: '400px',
                     width: '100%',
                     borderRadius: '20px',
                     background: 'white',
                     animation: 'fadeInUp 0.6s ease-out'
                 }}>
                {/* Animated Icon */}
                <div className="mb-4">
                    <div className="rounded-circle bg-danger bg-opacity-10 d-flex align-items-center justify-content-center mx-auto"
                         style={{
                             width: '100px',
                             height: '100px',
                             animation: isLoggingOut ? 'pulse 1.5s ease-in-out infinite' : 'none'
                         }}>
                        <FiLogOut className="text-danger" style={{ fontSize: '50px' }} />
                    </div>
                </div>

                {/* Title */}
                <h3 className="fw-bold mb-2" style={{ color: '#2d3748' }}>
                    Logging Out
                </h3>
                <p className="text-muted mb-4" style={{ fontSize: '15px' }}>
                    Please wait while we securely sign you out...
                </p>

                {/* Loading Spinner */}
                <div className="d-flex justify-content-center">
                    <div className="spinner-border text-danger" 
                         role="status"
                         style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>

                {/* Progress Bar */}
                <div className="mt-4">
                    <div className="progress" style={{ height: '4px', borderRadius: '10px' }}>
                        <div className="progress-bar bg-danger" 
                             style={{
                                 width: '100%',
                                 borderRadius: '10px',
                                 animation: 'progressAnimation 1.5s ease-in-out'
                             }}>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="mt-4 pt-3 border-top">
                    <p className="text-muted" style={{ fontSize: '13px' }}>
                        <FiLogOut className="me-1" /> Redirecting to login page...
                    </p>
                </div>
            </div>

            {/* Styles */}
            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes pulse {
                    0% {
                        transform: scale(1);
                    }
                    50% {
                        transform: scale(1.05);
                    }
                    100% {
                        transform: scale(1);
                    }
                }
                
                @keyframes progressAnimation {
                    from {
                        width: 0%;
                    }
                    to {
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};

export default Logout;